import { Breadcrumb } from "components";
import React, { Fragment, useState, useEffect } from "react";
import { translate } from "react-switch-lang";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Label,
  Input,
} from "reactstrap";
import CylinderChart from "../amCharts/Dcylinder";
import TraingleChart from "../amCharts/traingleColumnChart";
import MapPieChart from "../amCharts/mapPieChart";
import Clustered1 from "../amCharts/clustered1";
import OutletProductChart from "../amCharts/outletProductChart";
import Clustered3 from "../amCharts/clustered3";
import BulletPie from "../amCharts/bulletPiechart";
import Clustered2 from "../amCharts/empClustered";
import EmployeeTargetChart from "../amCharts/employeeTargetChart";
import Button from "@mui/material/Button";
import {
  getOutletPer,
  getEmployeePer,
  getTopEmp,
  getOutletSales,
  getRegionPer,
  getRegionSale,
} from "../../service/dashboardService";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  getGeneralM,
  getManager,
  getSeniorM,
  getVP,
} from "service/inentiveService";
import {
  getCurrentMonth,
  getCurrentYear,
  getYearsDropdownData,
} from "utils/date";
import {
  ADMIN_DEFAULT_POSITION,
  MONTHS,
  POSITIONS,
  QUARTERS,
} from "../../constant/variables";
import Loader from "components/loader";
import { getIsAdmin } from "utils";
import YearsDropdown from "components/dropdown/yearsDropdown";
import QuarterMonthsDropdown from "components/dropdown/quarterMonthsDropdown";

const Dashboard = (props) => {
  const defaultMonth = getCurrentMonth();
  const defaultYear = getCurrentYear();

  const defaultMonths = {
    month: defaultMonth,
    month1: defaultMonth,
    month2: defaultMonth,
    month3: defaultMonth,
    month4: defaultMonth,
    month5: defaultMonth,
    month6: defaultMonth,
  };

  const defaultYears = {
    year: defaultYear,
    year1: defaultYear,
    year2: defaultYear,
    year3: defaultYear,
    year4: defaultYear,
    year5: defaultYear,
    year6: defaultYear,
  };
  var client_id = JSON.parse(localStorage.getItem("clientId"));
  const [clientId, setClientId] = useState();
  const [outletper, setOutletper] = useState([]);
  const [outletperLoading, setOutletperLoading] = useState(false);
  const [regionper, setRegionper] = useState([]);
  const [regionperLoading, setRegionperLoading] = useState(false);
  const [empper, setEmpper] = useState([]);
  const [empperLoading, setEmpperLoading] = useState(false);
  const [topemp, setTopemp] = useState([]);
  const [topempLoading, setTopempLoading] = useState(false);
  const [regionsale, setRegionsale] = useState([]);
  const [regionsaleLoading, setRegionsaleLoading] = useState(false);
  const [outletSale, setOutletSale] = useState([]);
  const [outletSaleLoading, setOutletSaleLoading] = useState(false);
  const [months, setMonths] = useState(defaultMonths);
  const [years, setYears] = useState(defaultYears);
  const [mainLoader, setMainLoader] = useState(false);
  const [staffIds, setStaffIds] = useState({});
  const [staffId, setStaffId] = useState("select");
  const [substaffIds, setSubStaffIds] = useState({});
  const [substaffId, setSubStaffId] = useState("select");
  const [staffDrop, setStaffDrop] = useState([]);
  const [subDrop, setSubDrop] = useState([]);
  const [idHead, setIdHead] = useState("");
  const [subidHead, setSubIdHead] = useState("");
  const [loadings, setLoadings] = useState({});
  const [isOMSelected, setIsOMSelected] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedOutlet, setSelectedOutlet] = useState("");

  const isAdmin = getIsAdmin();

  var OwnerPosition = isAdmin
    ? ADMIN_DEFAULT_POSITION
    : JSON.parse(localStorage.getItem("Position"));

  let isOM = OwnerPosition === POSITIONS.OUTLET_MANAGER;

  if (isOMSelected) {
    isOM = isOMSelected;
  }

  useEffect(() => {
    dropDown();
  }, []);

  const dropDown = async () => {
    console.log(OwnerPosition, "Ownerporororo");
    if (OwnerPosition === "M") {
      try {
        const res1 = await getManager(client_id, months.month, years.year);
        setStaffDrop(res1);
      } catch (error) {
        console.log(error);
      }
      setIdHead("Select Outlet Manager");
    } else if (OwnerPosition === "SM") {
      console.log(OwnerPosition, "Ownerporororo");
      try {
        const res1 = await getSeniorM(client_id, months.month, years.year);
        setStaffDrop(res1);
      } catch (error) {
        console.log(error);
      }
      setIdHead("Select Manager");
    } else if (OwnerPosition === "GM") {
      try {
        const res1 = await getGeneralM(client_id, months.month, years.year);
        setStaffDrop(res1);
      } catch (error) {
        console.log(error);
      }
      setIdHead("Select Senior Manager");
    } else if (OwnerPosition === "VP") {
      try {
        const res1 = await getVP(client_id, months.month, years.year);
        setStaffDrop(res1);
      } catch (error) {
        console.log(error);
      }
      setIdHead("Select General Manager");
    }
  };

  const handleChangeMonth = (value, name) => {
    const newMonths = { ...months };
    newMonths[name] = value;
    setMonths(newMonths);
  };

  const handleChangeYear = (value, name) => {
    const newYears = { ...years };
    newYears[name] = value;
    setYears(newYears);
  };

  useEffect(() => {
    setClientId(client_id);
    // fetchData();
  }, []);

  const fetchData = (apiId) => {
    if (!isOM) {
      getOutlet(apiId);
      getOutSales(apiId);
      getRegtarget(apiId);
      getRegionSa(apiId);
      getToptenEmp(apiId);
    } else {
      getEmployee(apiId);
      getToptenEmp(apiId);
    }
  };

  const getRegtarget = async (clientId = client_id) => {
    try {
      setRegionperLoading(true);
      const res = await getRegionPer(clientId, months.month, years.year);
      setRegionper(res);
    } catch (error) {
      console.log(error);
    } finally {
      setRegionperLoading(false);
    }
  };
  const getOutlet = async (clientId = client_id) => {
    try {
      setOutletperLoading(true);
      const res = await getOutletPer(clientId, months.month, years.year);
      setOutletper(res || []);
    } catch (error) {
      console.log(error);
    } finally {
      setOutletperLoading(false);
    }
  };
  const getToptenEmp = async (clientId = client_id) => {
    setTopempLoading(true);
    try {
      const res = await getTopEmp(clientId, months.month, years.year);
      setTopemp(res && res.length ? res : []);
    } catch (error) {
      setTopemp([]);
      console.log("getTopEmp error", error);
    } finally {
      setTopempLoading(false);
    }
  };
  const getOutSales = async (clientId = client_id) => {
    try {
      setOutletSaleLoading(true);
      const res = await getOutletSales(clientId, months.month, years.year);
      console.log("Dashboard getOutSales", res, res || []);
      setOutletSale(res || []);
    } catch (error) {
      console.log(error);
    } finally {
      setOutletSaleLoading(false);
    }
  };
  const getEmployee = async (clientId = client_id) => {
    setEmpperLoading(true);
    try {
      const res = await getEmployeePer(clientId, months.month, years.year);
      setEmpper(res && res.length ? res : []);
    } catch (error) {
      console.log(error);
    } finally {
      setEmpperLoading(false);
    }
  };
  const getRegionSa = async (clientId = client_id) => {
    // setMainLoader(true)
    try {
      setRegionsaleLoading(true);
      const res = await getRegionSale(clientId, months.month, years.year);
      setRegionsale(res || []);
    } catch (error) {
      console.log(error);
    } finally {
      setRegionsaleLoading(false);
    }

    // setMainLoader(false)
  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const opent = Boolean(anchorEl);
  const id = opent ? "simple-popover" : undefined;

  const updateLoading = (index, status) => {
    const loading = `loading${index}`;
    const newLoadings = { ...loadings };
    newLoadings[loading] = status;
    setLoadings(newLoadings);
  };

  const getClientID = (index) => {
    let cId = clientId;
    const staffId = `staffId${index}`;
    const substaffId = `substaffId${index}`;
    if (substaffIds[substaffId]) {
      cId = substaffIds[substaffId];
    } else if (staffIds[staffId]) {
      cId = staffIds[staffId];
    }

    return cId;
  };

  const handleFilter = async () => {
    try {
      updateLoading("", true);
      const apiId = getClientID("");
      fetchData(apiId);
      handleClose();
      // const res = await getRegionSale(apiId, months.month, years.year);
      // setRegionsale(res);
      // updateLoading('', false);
      setIsOMSelected(
        OwnerPosition === POSITIONS.MANAGER && apiId !== client_id
      );
    } catch (error) {
      console.log(error);
      updateLoading("", false);
    }
  };

  const handlePost = async (value, name) => {
    const newStaffIds = { ...staffIds };
    newStaffIds[name] = value;
    setStaffIds(newStaffIds);
    if (value !== "select") {
      if (idHead === "Select Manager") {
        try {
          const res1 = await getManager(value, months.month, years.year);
          setSubDrop(res1);
        } catch (error) {
          console.log(error);
        }
        setSubIdHead("Select Outlet Manager");
      }
    } else {
      setSubDrop([]);
    }
  };

  const handleOutlet = async (value, name) => {
    const newSubstaffIds = { ...substaffIds };
    newSubstaffIds[name] = value;
    setSubStaffIds(newSubstaffIds);
  };

  const renderFilters = (index, handleFilter) => {
    const month = `month${index}`;
    const year = `year${index}`;
    const staffId = `staffId${index}`;
    const substaffId = `substaffId${index}`;
    const loading = `loading${index}`;
    const isLoading = loadings[loading];
    return (
      <div className="row" style={{ padding: 10 }}>
        <QuarterMonthsDropdown
          value={months[month]}
          onChange={(e) => handleChangeMonth(e.target.value, month)}
          className="col-lg-3 col-sm-6"
        />
        <YearsDropdown
          value={years[year]}
          className="col-md-12 col-sm-12 col-lg-3 mt-3 mt-sm-0 col-sm-6"
          onChange={(e) => handleChangeYear(e.target.value, year)}
        />
        {staffDrop?.length ? (
          <div className="col-lg-4 col-sm-12 mt-3 mt-lg-0">
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <Label>{idHead}</Label>
                <Input
                  type="select"
                  name="select"
                  value={staffIds[staffId]}
                  className="form-control digits uiStyleDashboard"
                  onChange={(e) => handlePost(e.target.value, staffId)}
                  disabled={OwnerPosition === "A" ? true : false}
                >
                  <option value="select">{"Select"}</option>
                  {staffDrop?.map((item, index) => {
                    return (
                      <option key={index} value={item.ID}>
                        {item.Name}
                      </option>
                    );
                  })}
                </Input>
              </div>
            </div>
          </div>
        ) : null}
        {/* {subDrop?.length !== 0 ? <div className="col-md-6 col-sm-12 mt-2">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <Label>{subidHead}</Label>
            <Input
              type="select"
              name="select"
              value={substaffIds[substaffId]}
              className="form-control digits uiStyleDashboard"
              onChange={(e) => handleOutlet(e.target.value, substaffId)}
              disabled={OwnerPosition === "A" ? true : false}
            >
              <option value="select">{"Select"}</option>
              {subDrop?.length !== 0 && subDrop?.map((item, index) => {
                return (
                  <option key={index} value={item.ID}>{item.Name}</option>
                )
              })}
            </Input>
          </div>
        </div>
      </div> : null} */}
        <div className="col-lg-2 col-sm-12 pt-3 pb-1 d-flex justify-content-start align-items-end">
          <Button
            variant="outlined"
            style={{ height: "38px", width: "80px" }}
            onClick={handleFilter}
          >
            {"Filter"}
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <Breadcrumb title={props.t("Dashboard")} />
      <Container fluid={true}>
        <div className="">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {/* <Tooltip title="Filter">
                      <IconButton>
                        <FilterList className="svgListStyle" onClick={handleClick} />
                      </IconButton>
                    </Tooltip> */}
            {/* <div /> */}
            <Card className="p-3" style={{ width: "100%" }}>
              {renderFilters("", handleFilter)}
            </Card>
          </div>
        </div>
        {mainLoader ? (
          <div className="homeloader">
            <div
              style={{
                height:
                  props.width >= 1200
                    ? "calc(100vh - 259px)"
                    : "calc(100vh - 238px)",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <CircularProgress />
            </div>
          </div>
        ) : (
          <Row>
            {!isOM ? (
              <>
                <Col sm="12">
                  <Card>
                    <CardHeader>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h6>
                          <span>Region -- Target vs Achievement</span>
                        </h6>
                      </div>
                    </CardHeader>
                    <CardBody className="pt-4">
                      <BulletPie
                        regionsale={regionper}
                        onSelect={setSelectedRegion}
                      />
                      {regionsaleLoading && <Loader />}
                      <div id="outletProductChartId" />
                    </CardBody>
                  </Card>
                </Col>
                {/* <Col sm="12">
              <Card>
                <CardHeader>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h6>
                      <span>{props.t("Regionwise -- Target vs Achievement")}</span>
                    </h6>
                  </div>
                </CardHeader>
                <CardBody className="pt-4">
                  <Clustered3 regionper={regionper} />
                  {regionperLoading && <Loader />}
                </CardBody>
              </Card>
            </Col> */}
                <Col sm="12">
                  <Card>
                    <CardHeader>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h6>
                          <span>
                            {props.t("Outlet -- Target Vs Achievement")}
                          </span>
                        </h6>
                        {selectedRegion ? (
                          <h6>
                            <span>Region -- {selectedRegion}</span>
                          </h6>
                        ) : null}
                      </div>
                    </CardHeader>
                    <CardBody className="pt-4">
                      <OutletProductChart
                        outletper={outletper}
                        region={selectedRegion}
                        onSelect={setSelectedOutlet}
                      />
                      {/* <MapPieChart outletSale={outletSale} /> */}
                      {outletSaleLoading && <Loader />}
                      <div id="employeeTargetId" />
                    </CardBody>
                  </Card>
                </Col>
                {/* <Col sm="12">
              <Card>
                <CardHeader>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h6>
                      <span>{props.t("Outletwise Performance")}</span>
                    </h6>
                  </div>
                </CardHeader>
                <CardBody className="pt-4">
                  <TraingleChart outletper={outletper} />
                  {outletperLoading && <Loader />}
                </CardBody>
              </Card>
            </Col> */}
                {/* <Col sm="12">
              <Card>
                <CardHeader>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h6>
                      <span>
                        {props.t("Outletwise Performance -- Target Vs Achievement")}
                      </span>
                    </h6>
                  </div>
                </CardHeader>
                <CardBody className="pt-4">
                  <Clustered1 outletper={outletper} />
                  {outletperLoading && <Loader />}
                </CardBody>
              </Card>
            </Col> */}
              </>
            ) : (
              <>
                <Col sm="12">
                  <Card>
                    <CardHeader>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h6>
                          <span>{props.t("Employeewise Performance")}</span>
                        </h6>
                      </div>
                    </CardHeader>
                    <CardBody className="pt-4">
                      <CylinderChart topemp={topemp} />
                      {topempLoading && <Loader />}
                    </CardBody>
                  </Card>
                </Col>
                <Col sm="12">
                  <Card>
                    <CardHeader>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h6>
                          <span>
                            {props.t("Employeewise -- Target vs Achievement")}
                          </span>
                        </h6>
                      </div>
                    </CardHeader>
                    <CardBody className="pt-4">
                      <EmployeeTargetChart
                        outletper={outletper}
                        outlet={selectedOutlet}
                      />
                      {empperLoading && <Loader />}
                    </CardBody>
                  </Card>
                </Col>
              </>
            )}
            <Col sm="12">
              <Card>
                <CardHeader>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h6>
                      <span>
                        {props.t("Employeewise -- Target vs Achievement")}
                      </span>
                    </h6>
                  </div>
                </CardHeader>
                <CardBody className="pt-4">
                  <EmployeeTargetChart
                    outletper={topemp}
                    outlet={selectedOutlet}
                  />
                  {empperLoading && <Loader />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </Fragment>
  );
};

export default translate(Dashboard);
